<template>
  <navigation-button :on-click="onClick" button-text="חיסכון בקופת גמל להשקעה" v-if="!promotionByHarel && !showSavingZone">
    <img :src="require('@/assets/nav/trophy.svg')"/>
  </navigation-button>
</template>

<script>

import NavigationButton from '@/base-components/app-header/NavigationButton';
import CustomerBenefits from '@/mixins/CustomerBenefits';

export default {
  name: 'SavingsNavigationButton',
  components: { NavigationButton },
  mixins: [CustomerBenefits],
  data() {
    return {
      showSavingZone: true,
    };
  },
  props: {
    onClick: {
      type: Function,
      required: true,
    },
  },
};
</script>
